import { useSyncExternalStore } from "react"

/**
 * Which row, if any, is showing its post-download receipt. One at a time: a
 * download from another row moves the receipt there, and dismissing it clears
 * it. Module state for the same reason as lib/row-error-store.ts: the rows
 * share no parent, and a windowed list remounts a row that scrolls back in,
 * which must not lose or resurrect the receipt.
 */
let current: string | null = null
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

export function openRowReceipt(owner: string): void {
  if (current === owner) return
  current = owner
  emit()
}

export function closeRowReceipt(owner: string): void {
  if (current !== owner) return
  current = null
  emit()
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useRowReceiptOpen(owner: string): boolean {
  return useSyncExternalStore(
    subscribe,
    () => current === owner,
    () => false,
  )
}
